import { ActionIcon, Box, Button, Group, Modal, Stack, Text } from "@mantine/core";
import { MdOutlineDelete } from "react-icons/md";
import { HistoryItemData } from "./types";
import { useDisclosure } from "@mantine/hooks";
import { useTranslation } from "react-i18next";

export interface HistoryItemProps {
    item: HistoryItemData;
    onSelect: (id: string) => void;
    onDelete: (id: string) => void;
}
export const HistoryItem = ({ item, onSelect, onDelete }: HistoryItemProps) => {
    const { t } = useTranslation();
    const [opened, { open, close }] = useDisclosure(false);

    const handleDelete = () => {
        close();
        onDelete(item.id);
    };
    const handleClick = () => {
        onSelect(item.id);
    };

    return (
        <>
            <Box p="xs" bg="gray.0" style={{ cursor: "pointer", borderRadius: "var(--mantine-radius-xs)" }}>
                <Group justify="space-between" gap="xs" preventGrowOverflow={false} wrap="nowrap">
                    <Text onClick={handleClick}>{item.title}</Text>
                    <ActionIcon variant="transparent" color="dark.4" onClick={open}>
                        <MdOutlineDelete size={24} />
                    </ActionIcon>
                </Group>
            </Box>
            <Modal opened={opened} onClose={close} title={t("history.deleteModalTitle")} centered>
                <Stack gap="sm">
                    <Text>{t("history.deleteModalDescription")}</Text>
                    <Group justify="flex-end" gap="sm">
                        <Button variant="outline" size="xs" onClick={close}>
                            {t("history.cancelLabel")}
                        </Button>
                        <Button variant="filled" size="xs" onClick={handleDelete}>
                            {t("history.deleteLabel")}
                        </Button>
                    </Group>
                </Stack>
            </Modal>
        </>
    );
};
